<script setup lang="ts">
const props = defineProps<{
  error?: string | boolean;
  numericOnly?: boolean;
  alphanumericOnly?: boolean;
  decimalOnly?: boolean;
}>();

const model = defineModel<string>();

const onInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  let val = target.value;

  if (props.numericOnly) {
    val = val.replace(/\D/g, "");
  } else if (props.alphanumericOnly) {
    val = val.replace(/[^a-zA-Z0-9]/g, "");
  } else if (props.decimalOnly) {
    val = val.replace(/[^0-9.]/g, "");
    const dotIndex = val.indexOf(".");
    if (dotIndex !== -1) {
      val = val.slice(0, dotIndex + 1) + val.slice(dotIndex + 1).replace(/\./g, "");
    }
    const [whole, decimals] = val.split(".");
    if (decimals !== undefined && decimals.length > 2) {
      val = `${whole}.${decimals.slice(0, 2)}`;
    }
  }

  model.value = val;
  target.value = val;
};

defineOptions({
  inheritAttrs: false,
});
</script>

<template>
  <input
    type="text"
    v-bind="$attrs"
    :value="model"
    @input="onInput"
    :class="[
      'w-full appearance-none rounded-[6px] border-0 px-4 py-3 text-sm font-medium text-on-primary-heading ring transition-colors outline-none ring-inset placeholder:text-on-primary-heading/40 focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-75 md:text-base',
      error ? 'ring-red-500' : 'ring-on-primary-heading',
    ]"
  />
</template>
